module.exports = __webpack_public_path__ + "static/media/select-back.de3426ab.png";